<template>
  <div class="editorContainer">
    <hotspots></hotspots>
  </div>
</template>

<script>
    //import { mapState, mapGetters, mapActions } from "vuex";
    import Hotspots from "@/editor/hotspots.vue";
    export default 
    {
        components:{
          hotspots:Hotspots
        },
        data()
        {
            return {
              isOpenFx:false
            }
        },
        mounted()
        {

        }
    }

</script>


<style scoped>
  .editorContainer
  {
    color: #fff;
    width: 100%;
    height: 100%;
  }
</style>


